import React from "react";
import { Button, ListGroup, ListGroupItem, Offcanvas } from "react-bootstrap";
import { formatDate } from "../utils/dateUtils";

export const PrescriptionOffcanvas = ({
	t,
	show,
	onHide,
	selectedPrescription,
	consultationOpen,
	onToggleConsultation,
	onAddAllToCart,
	loading,
	addedPrescriptions,
	isHospitalConnected,
	customerType,
	prescriptionDetails
}) => {
	const prescribedMedicines =
		selectedPrescription?.prescriptions?.length > 0
			? selectedPrescription.prescriptions
			: selectedPrescription?.items?.length > 0
				? selectedPrescription.items
				: prescriptionDetails?.prescriptions || [];

	return (
		<Offcanvas
			show={show}
			onHide={onHide}
			placement="start"
			backdrop={false}
			scroll
			style={{ width: "400px", zIndex: 1000 }}
			className="prescription-offcanvas"
			onClick={(event) => event.stopPropagation()}
		>
			<Offcanvas.Header closeButton className="bg-dark-subtle">
				<Offcanvas.Title style={{ fontSize: "1.25rem" }}>{t("Prescription Details")}</Offcanvas.Title>
			</Offcanvas.Header>
			<Offcanvas.Body style={{ padding: 0, overflow: "hidden" }}>
				{selectedPrescription && (
					<div style={{ height: "100%", overflowY: "auto", padding: "15px" }}>
						<div className="mb-3">
							<h6
								className="p-2 d-flex justify-content-between align-items-center bg-light border-bottom"
								style={{ cursor: "pointer", fontSize: "1rem" }}
								onClick={onToggleConsultation}
							>
								{t("Consultation Details")}
								<i className={`fa fa-chevron-${consultationOpen ? "up" : "down"}`} />
							</h6>
							{consultationOpen && (
								<div className="p-2" style={{ fontSize: "0.875rem" }}>
									<p className="mb-0">
										<strong>{t("Date")}:</strong> {formatDate(
											prescriptionDetails?.createdAt ||
											selectedPrescription?.createdAt
										)
										}
									</p>
									<p className="mb-0">
										<strong>{t("Doctor")}:</strong> {prescriptionDetails.doctor?.name || selectedPrescription?.doctor?.name || 'N/A'}
									</p>
									{/* <p className="mb-0">
									<strong>{t("Consultation For")}:</strong>{" "}
									{selectedPrescription.consultation_reason}
								</p> */}
								</div>
							)}
						</div>
						<div>
							<h6 className="p-2 bg-light border-bottom" style={{ fontSize: "1rem" }}>
								{t("Prescribed Medications")}
							</h6>
							<div className="my-1 d-flex flex-column justify-content-end">
								<Button variant="secondary" size="sm" onClick={onAddAllToCart} disabled={loading}>
									{loading ? t("Adding...") : t("Add All to Cart")}
								</Button>
								{addedPrescriptions?.has(selectedPrescription._id) ? (
									<div className="mt-2 text-muted small">
										<i className="fa fa-check-circle text-success me-1" />
										{t("This prescription is currently in the cart")}
									</div>
								) : null}
							</div>
							<ListGroup variant="flush">
								{prescribedMedicines.length > 0 ? (
									prescribedMedicines.map((item, index) => (
										<ListGroupItem
											key={`${item.medication_id || item.brandName || index}`}
											className="prescription-item-card"
											style={{
												padding: "10px",
												marginBottom: "10px",
												border: "1px solid #e0e0e0",
												borderRadius: "4px",
											}}
										>
											<div className="mb-1 d-flex justify-content-between align-items-center">
												<strong style={{ fontSize: "0.875rem" }}>
													{item.brandName || item.medicineName || item.medication_name || item.name || "N/A"}
												</strong>

												<span className="badge bg-primary" style={{ fontSize: "0.75rem" }}>
													{t("Qty")}: {item.medicineQunatity || item.qty || 0}
												</span>
											</div>

											<div className="text-muted" style={{ fontSize: "0.75rem" }}>
												<div>
													{t("Composition")}: {item.salt_composition || item.salt_composition_new || "N/A"}
												</div>
												<div>
													{t("Dosage")}: {item.dosage_name || "N/A"}
												</div>
												<div>
													{t("Duration")}: {item.duration || "N/A"}
												</div>
												<div>
													{t("Type")}: {item.type || "N/A"}
												</div>
												<div>
													{t("Instructions")}: {item.instruction || "N/A"}
												</div>
											</div>
										</ListGroupItem>
									))
								) : (
									<div className="text-center text-muted py-3">
										{t("No prescribed medicines found")}
									</div>
								)}
							</ListGroup>
						</div>
					</div>
				)}
			</Offcanvas.Body>
		</Offcanvas>
	);
}

export default PrescriptionOffcanvas;

